export default __webpack_public_path__ + "static/media/cyan-ship.1f4163c7.png";